import { PositionDc, SubtractPayload, UnitePayload } from "@evergis/api";

import { api } from "../../evergis/api";

import { GeometryOperation } from "./types";
import { Positions } from "../geometryEditor/geometryEditor";
import { FeatureDcExtended } from "../selectFeatures/types";

export const apiOperateGeometry = async (
  operation: GeometryOperation,
  positions: Positions,
  feature: FeatureDcExtended,
) => {
  const query = {
    name: feature.layer,
    id: feature.id,
  };

  switch (operation) {
    case "unit": {
      await api.layers.unite(query, {
        sr: feature.geometry.sr,
        type: feature.geometry.type,
        coordinates: positions as PositionDc,
      } as UnitePayload);
      break;
    }
    case "subtract": {
      await api.layers.subtract(query, {
        sr: feature.geometry.sr,
        type: feature.geometry.type,
        coordinates: positions as PositionDc,
      } as SubtractPayload);
      break;
    }
    default:
      break;
  }
};
